import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

const sendAcceptedEmail = (userId: string, gameName: string): Promise<any> => {
  const acceptedEmail = httpsCallable(firefuncs, "sendAcceptedEmail");
  return acceptedEmail({
    userId,
    gameName,
  });
};

const sendDeclinedEmail = (userId: string, gameName: string): Promise<any> => {
  const DeclinedEmail = httpsCallable(firefuncs, "sendDeclinedEmail");
  return DeclinedEmail({
    userId,
    gameName,
  });
};

const sendConfirmationNeededEmail = (
  userId: string,
  gameName: string,
  expTime: string,
): Promise<any> => {
  const confirmationNeededEmail = httpsCallable(
    firefuncs,
    "sendConfirmationNeededEmail",
  );
  return confirmationNeededEmail({
    userId,
    gameName,
    expTime,
  });
};

const sendConfirmationAcceptedEmail = (
  userId: string,
  gameName: string,
): Promise<any> => {
  const confirmationAcceptedEmail = httpsCallable(
    firefuncs,
    "sendConfirmationAcceptedEmail",
  );
  return confirmationAcceptedEmail({
    userId,
    gameName,
  });
};

const sendConfirmationDeclinedEmail = (
  userId: string,
  gameName: string,
): Promise<any> => {
  const confirmationDeclinedEmail = httpsCallable(
    firefuncs,
    "sendConfirmationDeclinedEmail",
  );
  return confirmationDeclinedEmail({
    userId,
    gameName,
  });
};

const sendRequestReceivedEmail = (
  hostId: string,
  gameName: string,
  senderName: string,
): Promise<any> => {
  const RequestReceivedEmail = httpsCallable(
    firefuncs,
    "sendRequestReceivedEmail",
  );
  return RequestReceivedEmail({
    hostId,
    gameName,
    senderName,
  });
};

interface PlayerEmailData {
  receiverId: string;
  gameName: string;
  senderName: string;
}

const sendPlayerConfirmedEmail = (data: PlayerEmailData): Promise<any> => {
  const { receiverId, gameName, senderName } = data;

  const PlayerConfirmedEmail = httpsCallable(
    firefuncs,
    "sendPlayerConfirmedEmail",
  );
  return PlayerConfirmedEmail({
    receiverId,
    gameName,
    senderName,
  });
};

const sendPlayerDeclinedEmail = (data: PlayerEmailData): Promise<any> => {
  const { receiverId, gameName, senderName } = data;

  const PlayerDeclinedEmail = httpsCallable(
    firefuncs,
    "sendPlayerDeclinedEmail",
  );
  return PlayerDeclinedEmail({
    receiverId,
    gameName,
    senderName,
  });
};

interface ContactEmailData {
  name: string;
  selection: string;
  message: string;
  userEmail: string;
}

const sendPlayerContactEmail = (data: ContactEmailData): Promise<any> => {
  const { name, selection, message, userEmail } = data;

  const PlayerContactEmail = httpsCallable(firefuncs, "sendPlayerContactEmail");
  return PlayerContactEmail({
    name,
    selection,
    message,
    userEmail,
  });
};

export default {
  sendAcceptedEmail,
  sendDeclinedEmail,
  sendConfirmationNeededEmail,
  sendConfirmationAcceptedEmail,
  sendConfirmationDeclinedEmail,
  sendRequestReceivedEmail,
  sendPlayerConfirmedEmail,
  sendPlayerDeclinedEmail,
  sendPlayerContactEmail,
};
